import { SxProps } from "@mui/material";

export const sxButtonConsultar: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 899px)': {
        width: 'stretch'
    }
}

export const sxTypographyAdvice: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
}

export const sxButtonText: SxProps = {
    textDecoration: 'underline',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    padding: 0,
    '&:hover': {
      color: '#164029',
    },
    color: '#383838'
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '30%',
    minWidth: '250px',
    maxHeight: '100vh',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '24px',
    overflow: 'auto',
}